export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "uk", label: "Українська", short: "UK" },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]["code"];

export const FALLBACK_LANGUAGE: LanguageCode = "en";
export const LANGUAGE_STORAGE_KEY = "lang";

export const DEFAULT_NAMESPACE = "translation";
